import Localization from "../../../../localization";
import { Text } from "../../../../components";
import { Flex } from "antd";

const Phone = ({ alarmModel, isIntegration, isConfigured }) => {
  return (
    <Flex gap={"1em"} align="center">
      {!!alarmModel?.image && !isIntegration && (
        <img src={alarmModel.image} style={{ height: "4.4rem" }} />
      )}
      <div>
        <Text
          level={5}
          weight={700}
          children={alarmModel?.name}
          type={isIntegration && isConfigured ? "secondary" : "primary"}
        />
        <Text
          color="secondary"
          className="m-5-t"
          children={`${Localization.general.phone_number}: ${
            alarmModel?.identifier ?? Localization.general.na
          }`}
        />
      </div>
    </Flex>
  );
};

export default Phone;
